import { get, post } from '../../utils/http';

export const fetchProjects = ({
  accountId,
  branchIds,
  from,
  to,
  allEmployees,
  filters,
  isArchived,
  full,
  showAllBranches,
  shiftDates
}) =>
  get(`/accounts/${accountId}/projects`, {
    branches: branchIds,
    from,
    to,
    employees: allEmployees ? 'all' : 'booked',
    filters,
    isArchived,
    listType: true,
    warnings: full,
    full,
    showAllBranches,
    shiftDates
  });

export const orderProject = ({
  accountId,
  projectId,
  supplierBranchId,
  supplierBookerId,
  comments,
  uniformId,
  instructions,
  poNumber,
  meetingSpot,
  onsiteContactName,
  onsiteContactPhone,
  isDraft,
  shifts,
  name,
  selfServeMethod
}) =>
  post(`/accounts/${accountId}/projects/${projectId}/order`, {
    supplierBranchId,
    supplierBookerId,
    comments,
    uniformId,
    instructions,
    poNumber,
    meetingSpot,
    onsiteContactName,
    onsiteContactPhone,
    isDraft,
    shifts,
    name,
    selfServeMethod
  });

export const fetchPresentations = ({ accountId, projectId, presentationHash }) =>
  get(`/accounts/${accountId}/projects/${projectId}/presentation`, { presentationHash });

export const copyMultipleBranchesProjects = ({
  accountId,
  branches,
  fromDate,
  toDate,
  weeksToCopy,
  copyEmployees,
  copyApplications,
  copyOrders,
  wait
}) =>
  post(`/accounts/${accountId}/projects/copy`, {
    branches,
    fromDate,
    toDate,
    weeksToCopy,
    copyEmployees,
    copyApplications,
    copyOrders,
    wait
  });

export const fetchProjectsPayroll = ({ accountId, branchIds, projectIds }) =>
  get(`/accounts/${accountId}/projects/payroll`, { branches: branchIds, projectIds });

export const fetchProjectsWarnings = ({ accountId, branchIds, from, to }) =>
  get(`/accounts/${accountId}/projects/warnings`, {
    branches: branchIds,
    from,
    to
  });

export const distributeProjectTips = ({
  accountId,
  projectId,
  tipAmount,
  mode,
  positionIds,
  positionGroups,
  locationIds,
  distributionMethod,
  payrollFieldId
}) =>
  post(`/accounts/${accountId}/projects/${projectId}/tips/distribute`, {
    tipAmount,
    mode,
    positionIds,
    positionGroups,
    locationIds,
    distributionMethod,
    payrollFieldId
  });
